import gql from 'graphql-tag'
import { pickDeep } from '@/helpers'
import _ from 'lodash'

export default config => async payload => {
  const {
    client,
    table,
    alias = 'item',
    allowedFields,
    primaryKey,
    defaultOutput,
    defaultFragments
  } = config

  const { output = defaultOutput, fragments = defaultFragments || '' } = payload

  let pk_columns = primaryKey.map(name => {
    if (!payload[name]) throw new Error(`${name} is undefined`)
    return `${name}: "${payload[name]}"`
  })

  const mutation = gql`
      mutation($input: ${table}_set_input) {
          ${alias}: update_${table}_by_pk(pk_columns: { ${pk_columns.join(
    ','
  )} }, _set: $input) {
            ${output}
          }
        }
        ${fragments}
      `
  const input = !_.isEmpty(allowedFields)
    ? pickDeep(payload, allowedFields)
    : payload

  const { data } = await client.mutate({
    mutation,
    variables: { input }
  })

  //console.debug(data, input)

  return data[alias]
}
